export default "__VITE_ASSET__DJlBC$QB__"